import { useEffect } from 'react';
import window from 'global/window';
import _ from 'lodash';

import { useStores } from 'src/hooks/use-stores';
import { hideZendeskWidget, closeZendeskWidget, showDecagonWidget } from 'shared/helpers/tools';

export default function useAdminChatWidget() {
  const { User } = useStores();

  useEffect(() => {
    closeZendeskWidget();
    hideZendeskWidget();
    return initializeDecagon(User);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

function initializeDecagon(User) {
  // Skip Decagon in E2E test environments - the widget's high z-index (99999999)
  // interferes with MUI modals during Playwright tests
  if (typeof window !== 'undefined' && window.__PLAYWRIGHT_TEST__) {
    return _.noop;
  }

  if (!window.duet) {
    const decagonInitScript = document.createElement(`script`);
    decagonInitScript.id = `chat-loader`;
    decagonInitScript.src = `https://decagon.ai/loaders/dutchie.js`;
    decagonInitScript.async = true;
    decagonInitScript.onload = () => {
      window.duet.setUserId(User.id);

      window.duet.setMetadata({
        email: User.email,
        name: User.fullName,
        userType: 'admin',
      });
    };
    document.body.appendChild(decagonInitScript);
  }

  // make sure it's not hidden from before
  showDecagonWidget();

  return () => window.duet?.hide();
}
